﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_searchEventList from './tpl/searchEventList.html';

import View_SearchEventListItem from './searchEventListItem';

export default Marionette.CollectionView.extend({
    tagName: 'searchEventListItem',
    className:"row",
    childViewContainer: '#searchEventListItem',
    childView: View_SearchEventListItem,
    getTemplate: function () {
        return tpl_searchEventList();
    },
    initialize: function () {
        this.app = this.options.app;
    }
});
